import * as React from "react"
import styled from "styled-components"
import { Spacer } from "../spacers"
import { theme } from "../../theme"
import ButtonTextSmall from "../typography/ButtonTextSmall"

interface ButtonProps {
  title: string
  onClick?: () => void
  icon?: React.ReactNode
  disabled?: boolean
  destructive?: boolean
  type?: any
  fullWidth?: boolean
  iconRight?: React.ReactNode
  id?: string
}

const ButtonContainer = styled.button<{
  disabled?: boolean
  destructive?: boolean
  fullWidth?: boolean
}>`
  cursor: ${(props) => (props.disabled ? undefined : "pointer")};
  border: ${(props) =>
    props.destructive
      ? `${props.theme.borders.smallWidth} solid ${props.theme.colors.red}`
      : `${props.theme.borders.smallWidth} solid ${props.theme.colors.greyDark}`};
  border-radius: ${(props) => props.theme.borders.buttonRadius};
  padding: 1rem 1.88rem;
  background-color: ${(props) => props.theme.colors.white};
  display: flex;
  align-items: center;
  ${(props) => props.disabled && "opacity: 0.4"};
  height: 50px;

  font-size: 16px;
  color: ${(props) => props.theme.colors.red};
  font-weight: 500;
  width: ${(props) => (props.fullWidth ? "100%" : undefined)};
  justify-content: ${(props) => (props.fullWidth ? "center" : undefined)};
  box-shadow: 0px 1px 3px 1px rgba(119, 119, 119, 0.25);

  :hover {
    background-color: ${(props) =>
      props.disabled ? undefined : props.destructive ? props.theme.colors.red : props.theme.colors.greyLighter};
    color: ${(props) => props.theme.colors.white};
  }
  :active {
    box-shadow: none;
  }
`

const PrimaryButton: React.FunctionComponent<ButtonProps> = ({
  title,
  onClick,
  icon,
  disabled,
  destructive,
  type,
  fullWidth,
  iconRight,
  id,
}) => {
  return (
    <ButtonContainer
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      destructive={destructive}
      type={type}
      fullWidth={fullWidth}
      id={id}
    >
      {icon}
      {icon && <Spacer spacing={0.5} />}
      {destructive ? <> {title}</> : <ButtonTextSmall>{title}</ButtonTextSmall>}
      {iconRight && (
        <>
          <Spacer spacing={0.5} /> {iconRight}
        </>
      )}
    </ButtonContainer>
  )
}

export default PrimaryButton
